/** @format */

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const ProtectUser = () => {
  const { customerInfo } = useSelector((state) => state.auth);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simule un temps d'attente pour vérifier les informations utilisateur
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500); // Temps de simulation (500ms ou ajustez selon vos besoins)

    return () => clearTimeout(timer);
  }, [customerInfo]);

  if (isLoading) {
    return <div>Chargement...</div>; // Affiche un spinner ou un message de chargement
  }

  if (customerInfo) {
    return <Outlet />;
  } else {
    return <Navigate to='/login' replace />;
  }
};

export default ProtectUser;
